<div class="holder">
  <h1>Memnuniyet Anketi Oluştur - {{ company?.name || "..." }}</h1>

  <table class="table table-bordered table-striped">
    <thead>
      <tr>
        <th width="200px">Girilecek Veri Başlığı</th>
        <th width="200px">Değişken</th>
        <th>Girilecek Veri</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let table of singleAnswerTables">
        <td>{{ table.title }}</td>
        <td>{{ table.variable }}</td>
        <td>
          <input type="text" class="form-control" [(ngModel)]="table.answer" />
        </td>
      </tr>
    </tbody>
  </table>

  <div *ngFor="let table of getMultipleAnswerTables()" style="margin-top: 2rem">
    <h2 style="margin-bottom: 1rem">
      {{ table.questionNumber.split(",").join(", ") }} -
      {{ getMultipleAnswerTableTitle(table) }}
    </h2>
    <table class="table table-striped table-bordered">
      <thead>
        <tr>
          <th>Girilecek Veri</th>
          <th width="150px" *ngIf="!table.hideCatBrand">Kategori</th>
          <th
            width="150px"
            *ngIf="
              !table.hideBrand && !table.showNotBrand && !table.hideCatBrand
            "
          >
            Marka
          </th>
          <th width="150px" *ngIf="table.showNotBrand && !table.hideCatBrand">
            Marka
          </th>
          <th width="50px">Sil</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let answer of table.answers; let i = index">
          <td class="answer-holder">
            <span>{{ answerLetters[i] }}.</span>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="answer.answer"
              (ngModelChange)="onAnswerChange()"
              [disabled]="
                table.copyAnswersFromQuestionNumber && !answer.copyDisabled
              "
            />
          </td>
          <td *ngIf="!table.hideCatBrand">
            <span *ngIf="!table.hideBrand">{{ answer.categoryUserType }}</span>
            <select
              class="form-control"
              [(ngModel)]="answer.categoryUserType"
              *ngIf="table.hideBrand && !table.showCategoryUserTypeSecondary"
            >
              <option value="">Seçiniz</option>
              <option
                *ngFor="let categoryUserType of categoryUserTypes"
                [value]="categoryUserType.value"
              >
                {{ categoryUserType.value }}
              </option>
            </select>

            <select
              class="form-control"
              [(ngModel)]="answer.categoryUserType"
              *ngIf="table.hideBrand && table.showCategoryUserTypeSecondary"
            >
              <option value="">Seçiniz</option>
              <option
                *ngFor="let categoryUserType of categoryUserTypesSecondary"
                [value]="categoryUserType.value"
              >
                {{ categoryUserType.value }}
              </option>
            </select>
          </td>
          <td
            *ngIf="
              !table.hideBrand && !table.showNotBrand && !table.hideCatBrand
            "
          >
            <select class="form-control" [(ngModel)]="answer.brandUserType">
              <option value="">Seçiniz</option>
              <option
                *ngFor="let brandUserType of brandUserTypes"
                [value]="brandUserType.value"
              >
                {{ brandUserType.value }}
              </option>
            </select>
          </td>
          <td *ngIf="table.showNotBrand && !table.hideCatBrand">
            <select class="form-control" [(ngModel)]="answer.brandUserType">
              <option value="">Seçiniz</option>
              <option
                *ngFor="let brandUserType of notBrandUserTypes"
                [value]="brandUserType.value"
              >
                {{ brandUserType.value }}
              </option>
            </select>
          </td>
          <td>
            <button class="btn btn-danger" (click)="deleteAnswer(table, i)">
              Sil
            </button>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="4">
            <button class="btn btn-primary" (click)="addAnswer(table)">
              Cevap Ekle
            </button>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>

  <div style="margin-top: 2rem">
    <h2 style="margin-bottom: 1rem">Karar Vericiler (Deciders)</h2>
    <table class="table table-bordered table-striped">
      <thead>
        <tr>
          <th>Soru</th>
          <th width="200px">S.. .. yanıtı verenlere</th>
          <th width="200px">S.. .. harici yanıt verenlere</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let q of conditionedQuestions()">
          <td>
            <b>{{ q.questionNumber }})</b> {{ replaceVariable(q.title) }}
          </td>
          <td>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="q.showIfLetter"
            />
          </td>
          <td>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="q.showIfNotLetter"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<button type="button" class="btn btn-primary" (click)="saveSurvey()">
  ANKETİ KAYDET
</button>

<button type="button" class="btn btn-secondary" (click)="generateQuestions()">
  Görmek için Soruları Oluştur
</button>

<button type="button" class="btn btn-secondary" (click)="fillDemo()">
  Demo Verileri Doldur
</button>

<button
  type="button"
  class="btn btn-secondary"
  [ngClass]="{ 'btn-loading': latestContentmentSurveyLoading }"
  (click)="fillFromLatestContentmentSurvey()"
>
  Son Anketten Verileri Doldur
</button>

<div *ngFor="let question of this.generatedQuestions">
  <div
    *ngIf="doShow(question)"
    style="
      box-sizing: border-box;
      padding: 1rem;
      border: 1px solid #ccc;
      border-radius: 0.5rem;
      margin-top: 1rem;
    "
  >
    <h2>
      {{ question.questionNumber }}) {{ replaceVariable(question.title) }}
    </h2>
    <ul *ngIf="!question.isOpenEnded">
      <li
        *ngFor="let answer of question.answers; let i = index"
        (click)="question.userAnswer = answerLetters[i]"
        [class.active]="question.userAnswer === answerLetters[i]"
      >
        <span
          >{{ answerLetters[i] }}. {{ replaceVariable(answer.answer) }}</span
        >
      </li>
    </ul>
    <div *ngIf="question.isOpenEnded">Açık Uçlu Soru</div>
  </div>
</div>
